// === General feedback ===
// A single, app-wide feedback entry point (footer). Opens an in-app modal with a
// free-text field and submits straight to the existing AHI Google Form — no
// redirect, no account. The form is the per-card feedback form, so its required
// fields (Task ID, Type of change, name) are filled with general-feedback
// defaults; the user's text lands in the "suggestion / comment" column.

import { pushScreen, back } from './nav.js';
import { showToast } from './toast.js';

const FORM_ID = '1FAIpQLScdsZTvoF2VJPtuPJgFDFzfL0fQbgNKKHzs2OtP5ScTk-__aQ';
const POST_URL = `https://docs.google.com/forms/d/e/${FORM_ID}/formResponse`;
const FIELD = {
  taskId: 'entry.859114132',   // required
  type: 'entry.302284166',     // required (multiple choice)
  comment: 'entry.575695359',  // required (free text)
  name: 'entry.1237461629',    // required
};

async function submitFeedback(text, name) {
  const body = new URLSearchParams();
  body.append(FIELD.taskId, 'General feedback (app)');
  body.append(FIELD.type, 'Other');
  body.append(FIELD.comment, text);
  body.append(FIELD.name, name || 'Anonymous (app)');
  // Google Forms accept a cross-origin POST but return an opaque response, so we
  // send it no-cors: a resolved fetch means the request left the browser (a real
  // browser POST with all required fields is recorded, verified 2026-07-08).
  await fetch(POST_URL, { method: 'POST', mode: 'no-cors', body });
}

export function setupFeedbackModal() {
  const overlay = document.getElementById('feedbackOverlay');
  if (!overlay) return;
  const nameEl = document.getElementById('feedbackName');
  const textEl = document.getElementById('feedbackText');
  const sendBtn = document.getElementById('btnSendFeedback');
  const statusEl = document.getElementById('feedbackStatus');
  const closeBtn = document.getElementById('btnCloseFeedback');

  function reset() {
    if (nameEl) nameEl.value = '';
    textEl.value = '';
    statusEl.hidden = true;
    sendBtn.hidden = false;
    sendBtn.disabled = false;
    sendBtn.textContent = 'Send feedback';
  }

  function open() {
    reset();
    overlay.removeAttribute('hidden');
    document.body.classList.add('search-open');
    textEl.focus();
    pushScreen(close);
  }

  function close() {
    overlay.setAttribute('hidden', '');
    document.body.classList.remove('search-open');
  }

  async function send() {
    const text = textEl.value.trim();
    if (!text) { textEl.focus(); return; }
    sendBtn.disabled = true;
    sendBtn.textContent = 'Sending…';
    try {
      await submitFeedback(text, nameEl ? nameEl.value.trim() : '');
    } catch { /* no-cors: nothing to read, treat as sent */ }
    sendBtn.hidden = true;
    statusEl.hidden = false;
    showToast('✓ Thanks for your feedback');
    setTimeout(back, 1400);
  }

  closeBtn.addEventListener('click', back);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) back(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) back();
  });
  sendBtn.addEventListener('click', send);

  // Expose to window.app for the footer onclick handler.
  if (window.app) window.app.openFeedback = open;
}
